// tslint:disable:object-literal-sort-keys
import { ca } from '@cian/analytics';
import { parseCookies } from '@cian/utils';
import { uniq } from 'lodash';

import { getOfferType } from '../components/search_filters/filters/utils';
import { IUser } from '../models/user';
import { IJsonQuery } from '../redux/modules/search/search';

interface IMapSectionToPage {
  [key: string]: string;
}

export const pagesWithYandexGeo = ['index', 'sale', 'rent'];

const mapSectionToPage: IMapSectionToPage = {
  index: 'main_page',
  sale: 'main_sale',
  rent: 'main_rent',
  'new-buildings': 'main_newobject',
  commercial: 'main_commercial',
  'daily-rent': 'main_daily',
};

export function clickGeoSuggest(category: string) {
  ca('event', {
    name: 'oldevent',
    category: mapSectionToPage[category],
    action: 'click_GEO_suggest',
  });
}

export function changeGeoSuggest(category: string, id: number) {
  ca('event', {
    name: 'oldevent',
    category: mapSectionToPage[category],
    action: 'change_GEO_suggest',
    label: id,
  });
}

export function trackSearchEvent(
  action: string,
  category: string,
  query: string,
  searchConditions: IJsonQuery,
  user: IUser,
  abGroup: number,
) {
  const cookies = parseCookies(document.cookie);

  ca('eventSite', {
    action,
    category: mapSectionToPage[category],
    label: query,
    modelVersion: 1,
    name: 'oldevent',
    page: {
      pageType: 'Home',
      siteType: 'desktop',
    },
    partner: {
      CriteoEmail: user.criteoEmail ? user.criteoEmail : '',
      CriteoNewCustomer: !cookies['_CIAN_GK'] ? 1 : 0,
      CriteoProducts: [],
    },
    searchConditions,
    schemaVersion: 1,
    user: {
      abGroup,
      balance: user.balance,
      cianUserId: user.id,
      email: user.email,
      type: user.userType ? user.userType : 'not_authorized',
      userId: user.userId,
    },
  });
}

export function clickSearchOnMapButtonOnFilter(category: string, query: string) {
  ca('event', {
    name: 'oldevent',
    category: mapSectionToPage[category],
    action: 'button_search_on_map',
    label: query,
  });
}

export function clickUserGeoStrictFilter(category: string) {
  ca('event', {
    name: 'oldevent',
    category: mapSectionToPage[category],
    action: 'click_GEO_suggest',
  });
}

export function changeValueUserGeoStrictFilter(category: string, geoType: string) {
  ca('event', {
    name: 'oldevent',
    category: mapSectionToPage[category],
    action: 'change_GEO_suggest',
    label: geoType,
  });
}

export function trackYandexGeoSuggestClick() {
  ca('event', {
    name: 'oldevent',
    category: 'GeoSuggest',
    action: 'Click',
    label: '',
  });
}

export function trackYandexGeoSuggestChange(geoType: string) {
  ca('event', {
    name: 'oldevent',
    category: 'GeoSuggest',
    action: 'Change',
    label: `${geoType}/yandex`,
  });
}

export function trackYandexGeoSuggestNotFound(requestText: string) {
  ca('event', {
    name: 'oldevent',
    category: 'GeoSuggest',
    action: 'NotFound',
    label: requestText,
  });
}

export function isYandexGeo(category: string): boolean {
  return pagesWithYandexGeo.includes(category);
}

export function trackClickGeoSuggest() {
  ca('event', {
    name: 'oldevent',
    category: 'GeoSuggest',
    action: 'Click',
    label: '',
  });
}

export function trackSelectGeoSuggestItem(group: string, type: string) {
  ca('event', {
    name: 'oldevent',
    category: 'GeoSuggest',
    action: 'Change',
    label: `${group}/${type}`,
  });
}

export function trackGeoSuggestNotFound(query: string) {
  ca('event', {
    name: 'oldevent',
    category: 'GeoSuggest',
    action: 'NotFound',
    label: query,
  });
}

export function trackAutoOfferChangeToSuburban(id: number, buildingTypes: string[]) {
  const labelOfferType = uniq(buildingTypes.map(getOfferType)).join(',');
  ca('event', {
    name: 'oldevent',
    category: 'GeoSuggest',
    action: 'AutoOfferChange',
    label: `${id}/${labelOfferType}/suburban`,
  });
}
